import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { SearchService } from '../../services/search/search.service';

@Component({
  selector: 'gp-client-search',
  templateUrl: './client-search.html',
  styleUrls: ['./client-search.scss']
})
export class ClientSearchComponent implements OnInit {

  // @Input('SaveId') saveId: string;
  @Output() SearchSelection: EventEmitter<any> = new EventEmitter();

  clientList: any[] =  [];
  accountList: any[] =  [];  

  searchControl = new FormControl('', [Validators.maxLength(12)]);

  constructor(private searchService: SearchService) { }

  ngOnInit(): void {
    this.searchControl.valueChanges
    .pipe(
      debounceTime(500)
    ).subscribe (
      searchText => {
        //if(searchText){
          this.searchService.searchClients(searchText).subscribe(
            searchResultResult => {
              this.clientList = <any[]>searchResultResult;                       
            }
          );
          this.searchService.searchAccounts(searchText).subscribe(
            searchResultResult => {
              this.accountList = <any[]>searchResultResult;                       
            }
          );
        //}  
      }
    );
  }

  onClientSelectionChange(selectedClient){ 
    this.SearchSelection.emit({searchType: 'client', searchResult: selectedClient});  
  }

  onAccountSelectionChange(selectedAccount){    
    this.SearchSelection.emit({searchType: 'account', searchResult: selectedAccount});      
  }

  onCloseSearch(){
    this.SearchSelection.emit({searchType: 'closeSearch', searchResult: null});      
  }

}
